"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "caulonia": {
    "7c91f8dc": [{
      "hkey": "c41c5401",
      "slug": "carrubbara-lisera",
      "name": "Carrubbara-Liserà",
      "primary": true,
      "skipSearch": false
    }],
    "carrubara": [{
      "hkey": "c41c5401",
      "slug": "carrubbara-lisera",
      "name": "Carrubbara-Liserà",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "ea67dc7b": [{
      "hkey": "f2f4d404",
      "slug": "san-nicola",
      "name": "San Nicola",
      "primary": true,
      "skipSearch": false
    }],
    "sannicola-pirarelli": [{
      "hkey": "f2f4d404",
      "slug": "san-nicola",
      "name": "San Nicola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "df960f73": [{
      "hkey": "b7314c5e",
      "slug": "cufo",
      "name": "Cufò",
      "primary": true,
      "skipSearch": false
    }],
    "strano-cufo": [{
      "hkey": "b7314c5e",
      "slug": "cufo",
      "name": "Cufò",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;